import React from 'react';
import AccommodationsDetailTemplate, { AccommodationData } from '../AccommodationsDetail/AccommodationsDetailTemplate';
import { images } from '../../components/shared/assets';

// Define Patagonia-specific accommodation data
const patagoniaAccommodations: Record<string, AccommodationData> = {
  'master-villa': {
    id: 'master-villa',
    title: 'Master Villa',
    size: '110 sq m / 1200 sq ft',
    description: 'Spacious 2-Bedroom Villa, each with 1 King bed or 2 Twin beds. Separate seating area. Wood burning fireplace, central heating, safe and minibar. Outdoor hot tub with view of the forest, Lake Sarmiento and Torres del Paine National Park. 2 En-suite bathroom, one with bathtub and separate shower, the other with shower only.',
    features: [
      'Two bedrooms with 1 King bed or 2 Twin beds each',
      'Separate seating area',
      'Wood burning fireplace',
      'Central heating',
      'Safe and minibar',
      'Outdoor hot tub',
      'View of forest, Lake Sarmiento and Torres del Paine',
      '2 En-suite bathrooms',
      'One bathroom with bathtub and separate shower',
      'One bathroom with shower only',
      'Bathrobes and slippers',
      'Hairdryer and toiletries',
      '1 Extra bed possible - Charges apply',
      '5 Persons maximum'
    ],
    sections: [
      { type: 'main-diptych' },
      { type: 'checklist' },
      { type: 'large-image' },
      { type: 'scattered-collage' },
      { type: 'large-image' },
      { type: 'floorplan', content: {
        description: 'Thoughtfully designed to maximize the stunning Patagonian views while providing a warm refuge from the elements. The open-plan layout creates a seamless flow between living and sleeping areas.'
      }},
      { type: 'large-image' },
      { type: 'triptych' },
      { type: 'large-image' },
      { type: 'you-may-like' }
    ],
    images: {
      hero: images.masterVilla || images.accommodations.superiorRoundSuite.hero,
      small: images.villas13 || images.accommodations.superiorRoundSuite.small,
      gallery: images.accommodations.superiorRoundSuite.gallery,
      floorplan: images.accommodations.superiorRoundSuite.floorplan
    },
    relatedRooms: [{
      id: 'standard-villa',
      title: 'Villas',
      description: 'Living area with wood-burning stove and a direct view to Torres del Paine. Bathroom with bathtub and walk-in shower. Measuring 90 sq m / 970 sq ft.',
      image: images.villas13 || images.accommodations.roundRooms.hero
    }]
  },
  'standard-villa': {
    id: 'standard-villa',
    title: 'Villas',
    size: '90 sq m / 970 sq ft',
    description: 'Living area with wood-burning stove and a direct view to Torres del Paine. Bathroom with bathtub and walk-in shower. Measuring 90 sq m / 970 sq ft.',
    features: [
      'Two bedrooms with 1 King bed or 2 Twin beds each',
      'Wood burning fireplace',
      'Central heating',
      'Safe and minibar',
      'Outdoor hot tub',
      'View of forest, Lake Sarmiento and Torres del Paine',
      'En-suite bathroom with bathtub and separate shower',
      'Bathrobes and slippers',
      'Hairdryer and toiletries',
      '1 Extra bed possible - Charges apply',
      '3 Persons maximum'
    ],
    sections: [
      { type: 'main-diptych' },
      { type: 'checklist' },
      { type: 'large-image' },
      { type: 'scattered-collage' },
      { type: 'large-image' },
      { type: 'floorplan', content: {
        description: 'Efficiently designed spaces that don\'t compromise on comfort or views. Every villa is oriented to capture the best vistas of Torres del Paine.'
      }},
      { type: 'large-image' },
      { type: 'triptych' },
      { type: 'large-image' },
      { type: 'you-may-like' }
    ],
    images: {
      hero: images.villas13 || images.accommodations.roundRooms.hero,
      small: images.masterVilla || images.accommodations.roundRooms.small,
      gallery: images.accommodations.roundRooms.gallery,
      floorplan: images.accommodations.roundRooms.floorplan
    },
    relatedRooms: [{
      id: 'master-villa',
      title: 'Master Villa',
      description: 'Two bedrooms & two bathrooms. Shared living room with wood-burning stove and a direct view to Torres del Paine. Measuring 110 sq m / 1200 sq ft.',
      image: images.masterVilla || images.accommodations.superiorRoundSuite.hero
    }]
  }
};

const AccommodationsDetailPatagonia: React.FC = () => {
  return (
    <AccommodationsDetailTemplate
      property="patagonia"
      accommodationData={patagoniaAccommodations}
    />
  );
};

export default AccommodationsDetailPatagonia;